module.exports = __webpack_public_path__ + "Participant HSA Notice 07_12_2024.pdf";